import { useMutation } from '@tanstack/react-query';
import { api } from '@/api';
import { CreateOpoContactRequestBody, UpdateOpoContactRequestBody } from '@/api/apis/opo/opo.types';
import { queryClient } from '@/queries';
import { opobffContactQueryKeys } from './opobff-contact.keys';

export const useCreateOpobffContactMutation = () => {
  return useMutation({
    mutationFn: (body: CreateOpoContactRequestBody) => api.opobffContact.createContact(body),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: opobffContactQueryKeys.getList() });
    },
  });
};

export const useUpdateOpobffContactMutation = () => {
  return useMutation({
    mutationFn: (variables: UpdateOpoContactRequestBody & { contactId: string }) =>
      api.opobffContact.updateContact(variables),
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({ queryKey: opobffContactQueryKeys.getList() });
      queryClient.invalidateQueries({ queryKey: opobffContactQueryKeys.getItem(variables.contactId) });
    },
  });
};

export const useDeleteOpobffContactMutation = () => {
  return useMutation({
    mutationFn: (contactId: string) => api.opobffContact.deleteContact(contactId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: opobffContactQueryKeys.getList() });
    },
  });
};
